/** @module MaterialSpec/BOM/ColorSwitchboard */
define([
	"dojo/_base/declare",
	"Specification/BOM/ProductSwitchboard"
], function(declare, ProductSwitchboard) {

	return declare(ProductSwitchboard, {
		idViewProperty: "bomActiveColorURLs",
		productStoreName: "bomColorStore",
		switchboardPath: "Child:ColorColorways",

		/**
		 * @override
		 * Refresh view if node from store is deleted
		 */
		_onDeleteNode: function(url) {
			const {store} = this;

			if (store && store.get(url)) {
				this.getView().refreshData();
			}
		}
	});
});